import variants from './image-variants.json';

type Manifest = Record<string, { h: string; w: number[] }>;

/**
 * next/image loader: local images are served as pre-generated static WebP variants (see scripts/gen-image-variants.mjs),
 * cached by the CDN and the browser for a year. Anything not in the manifest (external URLs, unknown files) is used as is.
 */
export default function imageLoader({ src, width }: { src: string; width: number; quality?: number }): string {
  const entry = (variants as Manifest)[src];
  if (!entry) return src;
  const pick = entry.w.find((w) => w >= width) ?? entry.w[entry.w.length - 1];
  const stem = src.replace(/^\/assets\/images\//, '').replace(/\.[A-Za-z0-9]+$/, '');
  return `/assets/images/r/${stem}-${pick}.${entry.h}.webp`;
}
